<template>
  <dl
    class="icon-details-unicodes display-inline-flex flex-items-center"
    style="
      --button-margin-bottom: 0;
      --button-background: transparent;
      --button-hover-background: transparent;
      --button-hover-color: var(--fa-dk-blue);
      --button-active-color: var(--fa-dk-blue);
      --margin-bottom: 0;
      --padding-left: 0;
      gap: var(--spacing-4xs);
    "
  >
    <dt
      class="muted sr-only"
      style="--margin-bottom: 0; font-weight: var(--font-weight-normal)"
    >
      {{ unicodeLabel }}:
    </dt>
    <dd style="--margin-bottom: 0">
      <button
        type="button"
        class="icon-action-unicode-copy flat compact display-inline-block padding-x-2xs"
        style="font-weight: var(--font-weight-normal); --button-color: var(--fa-navy)"
        :aria-label="`${
          isDuotone ? (justCopied === 'primaryunicode' ? 'Copied' : 'Copy Primary Unicode') : justCopied === 'primaryunicode' ? 'Copied' : 'Copy Unicode'
        }`"
        data-balloon-pos="up"
        @click="copyPrimaryUnicode"
      >
        <span class="text-monospace text-nowrap size-sm">{{ primaryUnicode }}</span>
      </button>
      <button
        v-if="isDuotone"
        type="button"
        class="icon-action-unicode-secondary-copy flat compact display-inline-block padding-x-2xs"
        style="font-weight: var(--font-weight-normal); --button-color: var(--fa-navy)"
        :aria-label="justCopied === 'secondaryunicode' ? 'Copied' : 'Copy Secondary Unicode'"
        data-balloon-pos="up"
        @click="copySecondaryUnicode"
      >
        <span class="text-monospace text-nowrap size-sm">{{ secondaryUnicode }}</span>
      </button>
    </dd>
  </dl>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'

  const JUST_COPIED_TIMEOUT = 2000

  export default {
    name: 'IconUnicodes',

    mixins: [EventTrackingMixin],

    inject: ['currentVersion'],

    props: {
      icon: {
        type: Object
      },
      isDuotone: {
        type: Boolean
      },
      isUsingModal: {
        type: Boolean,
        required: true
      },
      styling: {
        type: Object
      }
    },

    data() {
      return {
        justCopied: null
      }
    },

    computed: {
      primaryUnicode() {
        // TODO: We should probably fix the confusion between integer and hexadecimal representations of
        // this unicode.
        // See: https://github.com/FortAwesome/fontawesome/pull/2919#discussion_r1146873060
        //
        // We're lucky that calling `toString(16)` gives us the hexadecimal string we want, whether the original
        // original unicode is an integer or already a hexadecimal string. But it seems better to handle this type
        // difference explicitly and not to silently rely on JavaScript type coercion.
        return this.icon?.unicode?.toString(16)
      },

      secondaryUnicode() {
        if (this.currentVersion.number === 5) {
          return `10${this.icon.unicode}`
        } else {
          const u = this.icon.unicode.toString(16)
          return `${u}\\${u}`
        }
      },

      unicodeLabel() {
        if (this.isDuotone) {
          return 'Unicodes'
        } else {
          return 'Unicode'
        }
      }
    },

    methods: {
      copyPrimaryUnicode() {
        this.$clipboard(this.primaryUnicode)
        this.markCopied('primaryunicode')
        this.$posthog.capture('icon_primary_unicode_copy_click', {
          context: `${this.iconModalContext(this.isUsingModal)}`,
          icon_name: this.icon.name,
          icon_style: this.styling.style,
          icon_family: this.styling.family
        })
      },

      copySecondaryUnicode() {
        this.$clipboard(this.secondaryUnicode)
        this.markCopied('secondaryunicode')
        this.$posthog.capture('icon_secondary_unicode_copy_click', {
          context: `${this.iconModalContext(this.isUsingModal)}`,
          icon_name: this.icon.name,
          icon_style: this.styling.style,
          icon_family: this.styling.family
        })
      },

      markCopied(what) {
        this.justCopied = what
        setTimeout(() => {
          this.justCopied = null
        }, JUST_COPIED_TIMEOUT)
      }
    }
  }
</script>
